export const cultures = [
  {
    languageName: "English",
    cultureCode: "en-GB",
    rtl: false,
  },
  {
    languageName: "العربية",
    cultureCode: "ar-SA",
    rtl: true,
  },
  {
    languageName: "العربية",
    cultureCode: "ar-AE",
    rtl: true,
  },
];
